import React from 'react';
export const Star = _ref => {
  let {
    className
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    className: className
  }, /*#__PURE__*/React.createElement("title", null, "Full star"), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA400",
    d: "M29.728 11.552q0 0.384-0.48 0.864l-6.464 6.304 1.536 8.928q0 0.128 0 0.384 0 0.352-0.192 0.608t-0.544 0.288q-0.32 0-0.704-0.224l-8.032-4.224-8 4.224q-0.384 0.224-0.736 0.224t-0.544-0.288-0.192-0.608q0-0.128 0.032-0.384l1.536-8.928-6.496-6.304q-0.448-0.48-0.448-0.864 0-0.672 0.992-0.832l8.96-1.28 4.032-8.128q0.352-0.736 0.864-0.736t0.896 0.736l4 8.128 8.96 1.28q1.024 0.16 1.024 0.832z"
  }));
};
export default Star;